import { render, staticRenderFns } from "./order_list_view.vue?vue&type=template&id=82bef390&scoped=true&"
import script from "./order_list_view.vue?vue&type=script&lang=ts&"
export * from "./order_list_view.vue?vue&type=script&lang=ts&"
import style0 from "./order_list_view.vue?vue&type=style&index=0&id=82bef390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bef390",
  null
  
)

export default component.exports